import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {QuestionType} from '../../constants';
import {Question} from '../../models/underwriter.model';
import {parseOptions} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';

@Component({
    selector: 'app-question-radio-column-parent',
    templateUrl: './question-radio-column-parent.component.html',
    styleUrls: ['./question-radio-column-parent.component.scss'],
    standalone: false
})
export class QuestionRadioColumnParentComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() showLabel = true;
  @Input() showParent = true;
  @Input() itemQuestions: Question[] = [];
  @Output() parentQuestionAnswer = new EventEmitter();

  questions: Question[] = [];
  items: any[] = [];
  selectedItems: any[] = [];

  constructor(private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
      this.getChildrenQuestions();
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.itemQuestions?.currentValue !== changes?.itemQuestions?.previousValue) {
      this.itemQuestions = changes?.itemQuestions?.currentValue;
    }
  }

  getChildrenQuestions(): void {
    if (this.question) {
      if (this.itemQuestions?.length) {
        this.questions = this.itemQuestions;
      } else {
        this.questionService.getChildrenQuestions(this.question.cent_aq_question_id)
          .subscribe((children: Question[]) => {
            if (!children?.length) {
              return;
            }
            this.items = [];
            console.log('item quest', this.itemQuestions);
            children.forEach((q: Question) => {
              const questionCopy = Object.assign({}, q);
              if (!this.questions.some(g => g.cent_aq_question_id === questionCopy.cent_aq_question_id)) {
                this.questions.push(questionCopy);
              }
            });

            if (this.questions?.length) {
              for (const q of this.questions) {
                let options = [];
                options = parseOptions(q.options);
                this.items.push({label: q.question_copy, answers: options});
              }
            }
          });
      }
    }
  }

  activateNextButton(event): void {
    const questionIndex = this.questions?.findIndex((question: Question) => question.cent_aq_question_id === event.cent_aq_question_id);
    if (questionIndex > -1) {
      this.questions[questionIndex] = event;
    }
    this.emitEvent();
  }

  emitEvent(): void {
    const excludeUploadList = this.questions.filter((q: Question) => q.cent_aq_question_type_id !== QuestionType.upload);

    if (this.questions.every(q => q.answer)) {
      this.parentQuestionAnswer.emit(excludeUploadList);
    }
  }
}
